var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import is from 'is-lite';
import CloseButton from './CloseButton';
function FloaterContainer(props) {
    var content = props.content, footer = props.footer, onClick = props.onClick, open = props.open, positionWrapper = props.positionWrapper, showCloseButton = props.showCloseButton, styles = props.styles, title = props.title;
    var output = {
        content: React.isValidElement(content) ? (content) : (_jsx("div", __assign({ className: "__floater__content", style: styles.content }, { children: content }))),
    };
    if (title) {
        output.title = React.isValidElement(title) ? (title) : (_jsx("div", __assign({ className: "__floater__title", style: styles.title }, { children: title })));
    }
    if (footer) {
        output.footer = React.isValidElement(footer) ? (footer) : (_jsx("div", __assign({ className: "__floater__footer", style: styles.footer }, { children: footer })));
    }
    if ((showCloseButton || positionWrapper) && !is.boolean(open)) {
        output.close = _jsx(CloseButton, { onClick: onClick, styles: styles.close });
    }
    return (_jsxs("div", __assign({ className: "__floater__container", style: styles.container }, { children: [output.close, output.title, output.content, output.footer] })));
}
export default FloaterContainer;
//# sourceMappingURL=Container.js.map